if (!debounce) {
  function debounce(func, wait, immediate) {
  	var timeout;
  	return function() {
  		var context = this, args = arguments;
  		var later = function() {
  			timeout = null;
  			if (!immediate) func.apply(context, args);
  		};
  		var callNow = immediate && !timeout;
  		clearTimeout(timeout);
  		timeout = setTimeout(later, wait);
  		if (callNow) func.apply(context, args);
  	};
  };
}

$('a.back-to-top').click(function(event) {
  event.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, 500);
})
$( window ).scroll(debounce(function() {
  $('a.back-to-top').toggle($(window).scrollTop() > 300);
},500));
